import React, { PureComponent } from "react";

import Icon from "~/core/scripts/components/Icon";
import { getDateOfISOWeek, getWeekRangeDates, getData } from "../utils";
import { sortByKey, numberFormat } from "~/core/scripts/utils";
import { getWeek } from "date-fns";

function getRotation(change) {
  if (change < -0.1) {
    return "lower";
  }

  if (change > 0.047) {
    return "higher";
  }

  return "";
}

class LatestWeek extends PureComponent {
  state = {
    isLoading: true,
    numberFormat: {},
    rotation: "",
  };

  componentDidMount() {
    getData().then((data) => this.initWidget(data));
  }

  initWidget(data) {
    const sortedData = data
      .map((d) => ({
        ...d,
        date: getDateOfISOWeek(d.week, d.year),
      }))
      .sort(sortByKey("date", false));

    // Current week
    const thisWeekNumber = getWeek(new Date(), {
      weekStartsOn: 1,
      firstWeekContainsDate: 4,
    });
    // On mondays, there is no data point for current week
    const isCurrentWeekInDataset =
      thisWeekNumber === sortedData[sortedData.length - 1].week;
    const currentWeekIndex = isCurrentWeekInDataset
      ? sortedData.length - 1
      : null;
    const currentWeekDatum = sortedData[currentWeekIndex];
    const currentWeekRange = currentWeekDatum
      ? getWeekRangeDates(currentWeekDatum?.date)
      : [undefined, undefined];

    // Completed week
    const completedWeekIndex = isCurrentWeekInDataset
      ? sortedData.length - 2
      : sortedData.length - 1;

    const completedWeekDatum = sortedData[completedWeekIndex];
    const completedWeekRange = getWeekRangeDates(completedWeekDatum.date);

    // Week before completed week
    const weekBefore = sortedData[completedWeekIndex - 1];

    const percentageChange =
      (completedWeekDatum.abs - weekBefore.abs) / weekBefore.abs;
    const rotation = getRotation(percentageChange);

    // console.log("thisWeekNumber", thisWeekNumber);
    // const thisWeek = sortedData[sortedData.length - 1];
    // const thisWeekRange = getWeekRangeDates(thisWeek.date);

    // const prevData = sortedData[sortedData.length - 3];
    // const latestData = sortedData[sortedData.length - 2];
    // const weekRange = getWeekRangeDates(latestData.date);
    // const percentageChange = (latestData.abs - prevData.abs) / prevData.abs;
    // const rotation = getRotation(percentageChange);

    this.setState({
      thisWeek: currentWeekDatum,
      thisWeekStartLabel: currentWeekRange[0],
      thisWeekEndLabel: currentWeekRange[1],
      weekStartLabel: completedWeekRange[0],
      weekEndLabel: completedWeekRange[1],
      latestData: completedWeekDatum,
      rotation,
      isLoading: false,
    });
  }

  render() {
    if (this.state.isLoading) {
      return null;
    }

    const {
      thisWeek,
      thisWeekStartLabel,
      latestData,
      weekStartLabel,
      weekEndLabel,
      rotation,
    } = this.state;

    return (
      <div className="latestweek">
        <div className="latestweek__top">
          <div className="latestweek__label">letzte Meldewoche</div>
          <div className="latestweek__number-wrapper">
            <div className="latestweek__number">
              {numberFormat(latestData.abs)}
            </div>
            <div className="latestweek__icon">
              <Icon type="big-arrow" className={rotation} />
            </div>
          </div>
        </div>
        <div className="latestweek__subline">
          <strong>Fälle</strong> insgesamt in der Meldewoche vom{" "}
          {weekStartLabel} bis {weekEndLabel}
        </div>
        <div className="latestweek__subline2">
          {thisWeek ? (
            <>
              <strong className="latestweek__subline2 highlight">
                {numberFormat(thisWeek.abs)}
              </strong>{" "}
              Fälle bereits in der laufenden Woche vom {thisWeekStartLabel} bis
              heute
            </>
          ) : (
            <>Noch keine Meldungen in der aktuellen Woche</>
          )}
          <br />
        </div>
      </div>
    );
  }
}

export default LatestWeek;
